import MaterialCard from "../../../../__snowpack__/pkg/@mui/material/Card.js";
import styled from "styled-components";
export const CardContainer = styled(MaterialCard).withConfig({
  displayName: "cardstyles__CardContainer",
  componentId: "sc-18dum5-0"
})([""]);
